module.exports = __webpack_public_path__ + "img/Patch15.b25a7976.webp";